import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { CrudFilters, CrudSort, MetaQuery } from '@refinedev/core';
import { axiosInstance } from './axios';

class StoreCreditApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/storecredit');
  }

  async usages(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const url = this.baseURL + '/' + meta?.storeCreditId + '/usages';
      const response = await axiosInstance.get(`${url}`);
      return response.data?.data;
    } catch (error) {
      throw error;
    }
  }

  async cashoutEligibility(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    if (!meta?.storeCreditId) {
      throw new Error('storeCreditId is required for cashout eligibility.');
    }
    const response = await axiosInstance.get(
      `${this.baseURL}/${meta?.storeCreditId}/cashout/eligibility`,
    );
    if (response.data?.success === false || response.data?.status?.type === 'ERROR') {
      throw new Error(response.data?.status?.message || 'Unable to fetch cashout eligibility.');
    }
    return response.data?.data;
  }

  async cashout(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    if (!meta?.storeCreditId) {
      throw new Error('storeCreditId is required for cashout.');
    }
    const response = await axiosInstance.put(
      `${this.baseURL}/${meta?.storeCreditId}/cashout`,
      payload,
    );
    if (response.data?.success === false || response.data?.status?.type === 'ERROR') {
      throw new Error(response.data?.status?.message || 'Unable to initiate store credit cashout.');
    }
    return response.data?.data;
  }

  async issueCredit(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
  ): Promise<any> {
    const response = await axiosInstance.post(
      `${this.baseURL}/adhoc-issue`,
      payload,
    );
    if (response.data?.success === false || response.data?.status?.type === 'ERROR') {
      throw new Error(response.data?.status?.message || 'Unable to issue store credit.');
    }
    return response.data?.data;
  }
}

export default StoreCreditApiClient;
